import { render } from "./HeroiconsOutlineInbox.vue?vue&type=template&id=fd12475c"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineInbox.vue"]])

export default __exports__